import axios from "axios";
import authHeader from "@/services/auth-header";

class DisclosureLogEntryService {
  get(fileDataId) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/BytePro/DisclosureLogEntry/${fileDataId}`,
        {
            headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }
}

export default new DisclosureLogEntryService();
